import { TextField } from '@mui/material';
import { ChangeEvent, useState } from 'react';

import { type InlineEditorProps } from './table-types';

export function TableEditorNumber<TData>({
  initialValue,
  row,
  column,
  updateRow,
}: InlineEditorProps<TData>) {
  const [value, setValue] = useState(initialValue);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  // We'll only update the external data when the input is blurred
  const onBlur = () => {
    updateRow(row.original, column.id, value);
  };

  return (
    <TextField
      variant="outlined"
      size="small"
      type="number"
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      fullWidth
      slotProps={{
        input: {
          inputProps: {
            step: 0.01,
          },
        },
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          backgroundColor: 'background.paper',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
          '&.Mui-focused': {
            backgroundColor: 'background.paper',
          },
        },
        '& .MuiOutlinedInput-input': {
          padding: '8px 12px',
        },
      }}
    />
  );
}
